var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAparat = function SvgAparat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M11.005.991a10.41 10.41 0 0 0-9.618 6.42A10.4 10.4 0 0 0 8.97 21.6a10.41 10.41 0 0 0 10.685-4.424A10.402 10.402 0 0 0 11.005.991M5.11 6.181a2.97 2.97 0 0 1 5.378-1.103 2.97 2.97 0 0 1-4.096 4.146A2.97 2.97 0 0 1 5.111 6.18m4.324 8.988a2.97 2.97 0 0 1-5.38 1.097 2.97 2.97 0 0 1 4.1-4.141 2.97 2.97 0 0 1 1.28 3.044m1.26-2.405a1.322 1.322 0 0 1-.491-2.387 1.321 1.321 0 1 1 .492 2.387m6.2 3.838a2.97 2.97 0 1 1-5.833-1.126 2.97 2.97 0 0 1 5.833 1.126m-1.967-5.505a2.972 2.972 0 0 1-2.19-4.037 2.97 2.97 0 0 1 5.671 1.68 2.97 2.97 0 0 1-3.48 2.36z"
  })));
};
export default SvgAparat;